import ApiClient from './ApiClient';

class CampaignsAgentAPI extends ApiClient {
  constructor() {
    super('campaign_agents', { accountScoped: true });
  }

  fetchCampaignAgent(params = {}) {
    return axios.get(`${this.url}`, { params });
  }

  fetchCampaignAgentFilterList(params = {}) {
    const { payload, ...restParams } = params;
    return axios.post(
      `${this.url}/filter`,
      { payload },
      {
        params: {
          ...restParams,
        },
      }
    );
  }

  createCampaignAgent(payload) {
    return axios.post(`${this.url}/`, payload);
  }

  deleteCampaignAgent(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  getCampaignAgentDetail(id) {
    return axios.get(`${this.url}/${id}`);
  }

  updateCampaignAgent(id, payload) {
    return axios.put(`${this.url}/${id}`, payload);
  }

  // check eligible audience
  checkEligibleAudience(payload) {
    return axios.post(`${this.url}/check_eligible_audience`, payload);
  }

  // get campaign audiences with stats
  getCampaignAudiences(campaignId, params = {}) {
    return axios.get(`${this.url}/${campaignId}/campaign_audiences`, {
      params,
    });
  }

  getCampaignAudiencesFilterList(campaignId, params = {}) {
    const { payload, ...restParams } = params;
    return axios.post(
      `${this.url}/${campaignId}/campaign_audiences/filter`,
      { payload },
      {
        params: {
          ...restParams,
        },
      }
    );
  }
}

export default new CampaignsAgentAPI();
